import React, {useState} from 'react';
import {RequestVisitorDto} from "../../../modules/vms/dto/RequestVisitorDto";
import {FormattedMessage, useIntl} from "react-intl";
import {DictItemDto} from "../../../modules/dict/dto/DictItemDto";
import VisitorAccessLogListDialog from "./VisitorAccessLogListDialog";
import {HttpStatus} from "../../../modules/common/enums/HttpStatus";
import {Card, CardContent, CardHeader, Chip} from "@mui/material";
import Descriptions from "../../../components/Descriptions";
import DescriptionItem from "../../../components/DescriptionItem";
import {RequestVisitorApi} from "../../../modules/vms/api/RequestVisitorApi";
import {VisitorStatus} from "../../../modules/vms/enums/VisitorStatus";
import VisitorPhotoDialog from "./VisitorPhotoDialog";
import VisitorAttachFilesDialog from "./VisitorAttachFilesDialog";
import {IdTypes} from "../../../modules/vms/enums/IdTypes";
import EnumItemLabel from "../../../components/EnumItemLabel";

export type RequestVisitorDetailProps = {
    requestVisitor: RequestVisitorDto;
    visitorTypes?: Array<DictItemDto>;
    idTypes?: Array<DictItemDto>;
    driveTypes?: Array<DictItemDto>;
    plateNumberColors?: Array<DictItemDto>;
    vehicleUseTypes?: Array<DictItemDto>;
    vehicleTypes?: Array<DictItemDto>;
};

const RequestVisitorDetail: React.FC<RequestVisitorDetailProps> = (props) => {
    const intl = useIntl();

    const [openAccessLogModal, setOpenAccessLogModal] = useState(false);

    const [tabIndex, setTabIndex] = React.useState(0);
    const [openPhotoDialog, setOpenPhotoDialog] = React.useState(false);
    const [openAttachFileDialog, setOpenAttachFileDialog] = React.useState(false);

    const [accessLogs, setAccessLogs] = useState([]);

    const fetchAccessLogList = async () => {
        const responseResult = await RequestVisitorApi.getVisitorAccessLogList(props.requestVisitor.id);
        if (responseResult.status === HttpStatus.SUCCESS) {
            setAccessLogs(responseResult.data);
            setOpenAccessLogModal(true);
        }
    };

    const renderVisitorDetail = () => {

        const carryGoods = props.requestVisitor.carryGoods;
        let carryGoodsJson;
        if (carryGoods) {
            carryGoodsJson = JSON.parse(carryGoods);
        }
        return (
            <Card>
                <VisitorPhotoDialog open={openPhotoDialog}
                                    onClose={() => setOpenPhotoDialog(false)}
                                    requestVisitor={props.requestVisitor}/>
                <VisitorAttachFilesDialog open={openAttachFileDialog}
                                          onClose={() => setOpenAttachFileDialog(false)}
                                          requestVisitor={props.requestVisitor}/>
                <CardHeader title={intl.formatMessage({id: 'VMS_REQUEST_VISITOR_GENERAL_INFO'})}/>

                <CardContent>

                    <Descriptions>
                        <DescriptionItem label={intl.formatMessage({id: 'VMS_REQUEST_VISITOR_NAME'})}>
                            {props.requestVisitor.fullName}
                        </DescriptionItem>
                        <DescriptionItem label={intl.formatMessage({id: 'VMS_REQUEST_VISITOR_MOBILE'})}>
                            {props.requestVisitor.mobile}
                        </DescriptionItem>
                        <DescriptionItem label={intl.formatMessage({id: 'VMS_REQUEST_VISITOR_COMPANY'})}>
                            {props.requestVisitor.company}
                        </DescriptionItem>

                        <DescriptionItem label={intl.formatMessage({id: 'VMS_REQUEST_VISITOR_EMAIL'})}>
                            {props.requestVisitor.email}
                        </DescriptionItem>
                        {props.requestVisitor.remarks!==''?<DescriptionItem label={intl.formatMessage({id: 'VMS_REQUEST_VISITOR_EMPLOYEE_NO'})}>
                            {props.requestVisitor.remarks}
                        </DescriptionItem>:null}
                        <DescriptionItem label={intl.formatMessage({id: 'VMS_REQUEST_VISITOR_ID_NUMBER'})}>
                            {props.requestVisitor.idNumber}&nbsp;

                            <Chip variant="outlined" color="primary" size="small"
                                  label={<EnumItemLabel value={props.requestVisitor.idType} map={IdTypes.Map}/>}/>
                        </DescriptionItem>
                        <DescriptionItem label={intl.formatMessage({id: 'VMS_REQUEST_VISITOR_PLATE_NUMBER'})}>
                            {props.requestVisitor.plateNumber}
                        </DescriptionItem>
                        {/*<DescriptionItem label={intl.formatMessage({id: 'VMS_REQUEST_VISITOR_PLATE_NUMBER_COLOR'})}>*/}
                        {/*    {props.requestVisitor.plateNumberColor &&*/}
                        {/*    <FormattedMessage id={PlateNumberColor.Map.get(props.requestVisitor.plateNumberColor)}/>}*/}
                        {/*</DescriptionItem>*/}
                        {/*<DescriptionItem label={intl.formatMessage({id: 'VMS_REQUEST_VISITOR_VEHICLE_TYPE'})}>*/}
                        {/*    {props.requestVisitor.vehicleType &&*/}
                        {/*    <FormattedMessage id={VehicleType.Map.get(props.requestVisitor.vehicleType)}/>}*/}
                        {/*</DescriptionItem>*/}
                        {/*<DescriptionItem*/}
                        {/*    label={intl.formatMessage({id: 'VMS_REQUEST_VISITOR_VEHICLE_REGISTRATION_DATE'})}>*/}
                        {/*    {StringUtils.formatDate(props.requestVisitor.vehicleRegistrationDate)}*/}
                        {/*</DescriptionItem>*/}
                        {/*<DescriptionItem label={intl.formatMessage({id: 'VMS_REQUEST_VISITOR_VEHICLE_FUEL_TYPE'})}>*/}
                        {/*    {props.requestVisitor.vehicleFuelType &&*/}
                        {/*    <FormattedMessage id={VehicleFuelType.Map.get(props.requestVisitor.vehicleFuelType)}/>}*/}
                        {/*</DescriptionItem>*/}
                        {/*<DescriptionItem label={intl.formatMessage({id: 'VMS_REQUEST_VISITOR_VEHICLE_EMISSION_STANDARD'})}>*/}
                        {/*    {props.requestVisitor.vehicleEmissionStandard &&*/}
                        {/*    <FormattedMessage id={VehicleEmissionStandard.Map.get(props.requestVisitor.vehicleEmissionStandard)}/>}*/}
                        {/*</DescriptionItem>*/}
                        <DescriptionItem label={intl.formatMessage({id: 'VMS_REQUEST_VISITOR_STATUS'})}>
                            <FormattedMessage id={VisitorStatus.Map.get(props.requestVisitor.status)}/>
                        </DescriptionItem>
                        {/*<DescriptionItem label={intl.formatMessage({id: 'VMS_REQUEST_VISITOR_PHOTO'})}>*/}
                        {/*    {props.requestVisitor.portraitFileId ?*/}
                        {/*        <a href={'javascript:void(0)'} onClick={() => setOpenPhotoDialog(true)}>*/}
                        {/*            <FormattedMessage id={'VMS_REQUEST_VISITOR_PHOTO_DOWNLOAD'}/>*/}
                        {/*        </a> : null}*/}
                        {/*</DescriptionItem>*/}
                        {/*<DescriptionItem label={intl.formatMessage({id: 'VMS_REQUEST_VISITOR_ATTACH_FILE'})}>*/}
                        {/*    {props.requestVisitor.attachFiles ?*/}
                        {/*        <a href={'javascript:void(0)'} onClick={() => setOpenAttachFileDialog(true)}>*/}
                        {/*            <FormattedMessage id={'VMS_REQUEST_VISITOR_ATTACH_FILE_DOWNLOAD'}/>*/}
                        {/*        </a> : null}*/}
                        {/*</DescriptionItem>*/}
                        {/*<DescriptionItem*/}
                        {/*    label={intl.formatMessage({id: 'VMS_REQUEST_VISITOR_CONSTRUCTION_ORDER_NUMBER'})}>*/}
                        {/*    {props.requestVisitor.constructionOrderNumber}*/}
                        {/*</DescriptionItem>*/}
                        <DescriptionItem label={intl.formatMessage({id: 'VMS_VISIT_REQUEST_TRANSPORT_GOODS'})}>
                            {carryGoodsJson && carryGoodsJson.transportGoods}
                        </DescriptionItem>
                        <DescriptionItem label={intl.formatMessage({id: 'VMS_VISIT_REQUEST_PERSONAL_GOODS_DESCRIPTION'})}>
                            {carryGoodsJson && carryGoodsJson.personalGoodsDescription}
                        </DescriptionItem>
                    </Descriptions>
                </CardContent>
            </Card>
        )

    }

    const renderAccessDetail = () => {

        return (
            <Card>
                <CardHeader title={intl.formatMessage({id: 'VMS_REQUEST_VISITOR_GENERAL_INFO'})}/>

                <CardContent>

                    <Descriptions>
                        <DescriptionItem label={intl.formatMessage({id: 'VMS_REQUEST_VISITOR_ACCESS_CARD_NUMBER'})}>
                            {props.requestVisitor.accessCardNumber}
                        </DescriptionItem>
                        <DescriptionItem label={intl.formatMessage({id: 'VMS_VISITOR_ACCESS_LOG_LIST'})}>
                            <a href={'javascript:void(0)'} onClick={fetchAccessLogList}><FormattedMessage
                                id={'VMS_VISITOR_ACCESS_LOG_LIST_FETCH'}/></a>
                        </DescriptionItem>


                    </Descriptions>
                </CardContent>
            </Card>
        )

    }
    return (
        <div>
            <VisitorAccessLogListDialog open={openAccessLogModal} onClose={() => setOpenAccessLogModal(false)}
                                        accessLogs={accessLogs}/>
            {renderVisitorDetail()}
            {/*{renderAccessDetail()}*/}

        </div>
    );
};

export default RequestVisitorDetail;
